<template>
  <div class="col-12">
    <searchFilter
      :items="generateItems"
      :headers="headers_fields"
      :filters="filters"
      :title="title"
      :changePage="changePage"
      :current-page="1"
      :perPage="perPage"
      :total_pages="totalPages"
      :totalRows="totalRows"
      :pageLoading="loading"
      :filterheaders="filterheaders"
      :insert_evidence="false"
      :showRemove="false"
      :allowOperate="false"
      :showPaganationTop="false"
      :defaultViewCount="defaultViewCount"
      :permissionButtons="permissionButtons"
      :dataNotExist="$lang.dataNotExist"
      ref="searchFilter"
      @getFilterItems="getFilterItems"
      @selectedaAll="selectedaAll"
      @changeSelected="changeSelected"
      @changeViewCount="changeViewCount"
    >
      <template slot="loader">
        <LoadingSpinner :loading="loading" />
      </template>
      <template slot="headerButtons">
        <button
          v-if="filterCatch && Object.values(paramsData).length > 0"
          type="button"
          class="btn btn-danger ml-2 position-relative"
          @click="deleteFilterCacheResource"
          v-b-tooltip.hover
          :title="`پاک کردن فیلتر`"
        >
          <mdicon
            name="filter-remove-outline"
            size="24"
            class="cursor_pointer"
          />
        </button>
        <button
          type="button"
          class="btn btn-lightgray ml-2 position-relative"
          v-if="filterheaders.length > 0"
          @click="openFilter"
          v-b-tooltip.hover
          :title="`فیلتر`"
        >
          <span
            class="badge badge-pill badge-danger position-badge"
            v-if="filterUrlLenght()"
            >{{ filterUrlLenght() }}</span
          >
          <i class="fa fa-filter"></i>
        </button>
      </template>
    </searchFilter>
  </div>
</template>

<script>
import searchFilter from "@/components/base/searchFilter";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateStoreGetters } from "@/shared/utils";

export default {
  components: {
    searchFilter,
    LoadingSpinner,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    allowFields: {
      type: Object,
      default: null,
    },
    url: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      table_data: [],
      headers_fields: [],
      totalRows: 0,
      perPage: 0,
      totalPages: 0,
      filters: null,
      loading: false,
      personsSelected: [],
      filterheaders: [],
      permissionButtons: [],
      paramsData: {},
      paramsPage: {},
      filterCatch: true,
      defaultViewCount: 10,
    };
  },
  computed: {
    generateItems() {
      return this.table_data.map((x) => {
        return {
          selected: false,
          ...x,
          showCheckBox: true,
        };
      });
    },
    roles() {
      return generateStoreGetters(["userInfo", "roles"]) || [];
    },
  },
  async created() {
    this.loading = true;
    await this.fillTable();
    this.loading = false;
  },
  methods: {
    pathOr,

    getFilterData(params) {
      this.params = params;
      this.fetchData();
    },
    changeViewCount(item) {
      this.paramsPage["per_page"] = item;
      this.fetchData();
    },
    changeSelected(row, event) {
      const code = pathOr(null, ["code"], row);
      const alreadySelected = this.personsSelected.find((x) => x === code);
      if (!event && alreadySelected) {
        this.personsSelected = [
          ...this.personsSelected.filter((i) => i !== code),
        ];
        this.$emit("updateItemsSelected", this.personsSelected);
        return;
      }

      if (event && !alreadySelected) {
        this.personsSelected.push(code);
        this.$emit("updateItemsSelected", this.personsSelected);
      }
    },
    selectedaAll(items, checked) {
      items.map((row) => {
        this.changeSelected(row, checked);
      });
    },
    getFilterItems(item) {
      this.paramsPage = item;
      this.fetchData();
    },
    async openFilter() {
      this.$refs.searchFilter.showFilter();
    },
    getCatchFilterResource() {
      const resource = this.url
        .split(`${this.$config.api_url}`)
        .filter(function (el) {
          return el != "";
        })[0]
        .split("?")[0];

      return resource ? resource : null;
    },
    async getFilterCacheResource() {
      try {
        const resource = this.getCatchFilterResource();
        const url =
          this.$config.api_url + this.$config.resources.filter_cache_resource;
        let prms = {
          resource: resource,
        };
        const response = await this.$httpService.get(url, prms);
        let data = response.data.data;
        let params = data.query_params;

        for (const key in params) {
          if (params.hasOwnProperty.call(params, key)) {
            const element = params[key];
            this.paramsPage[key] = element;
          }
        }
      } catch (error) {
        this.$generateError(error);
      }
    },
    async deleteFilterCacheResource() {
      try {
        const resource = this.getCatchFilterResource();
        const url =
          this.$config.api_url + this.$config.resources.filter_cache_resource;
        let params = {
          resource: resource,
        };
        const response = await this.$httpService.delete(url, params);
        this.$refs.searchFilter.allFilterRemove();
        this.$notify.success(response.data.message);
        this.paramsPage = {};
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      }
    },
    async fillTable() {
      let params = await this.getFilterCacheResource();
      if (this.filterCatch && params && Object.keys(params).length > 0) {
        for (const key in params) {
          if (params.hasOwnProperty.call(params, key)) {
            const element = params[key];
            this.paramsPage[key] = element;
          }
        }
      } else {
        this.paramsPage["page"] = 1;
        this.paramsPage["per_page"] = this.defaultViewCount;
      }
      await this.fetchData();
      return true;
    },
    filterUrlLenght() {
      if (this.params && Object.keys(this.params).length > 0) {
        return Object.keys(this.params).length;
      }
      if (this.inputSearch) {
        return "1";
      }
    },

    changePage(page) {
      if (page != this.paramsPage["page"]) {
        this.paramsPage["page"] = page;
        this.fetchData();
      }
    },
    async fetchData() {
      try {
        this.table_data = [];
        this.loading = true;
        for (const key in this.params) {
          if (Object.hasOwnProperty.call(this.params, key)) {
            this.paramsPage[key] = this.params[key];
          }
        }
        const { per_page, order_by, page, locale_id, ...otherFilter } =
          this.paramsPage;
        this.paramsData = otherFilter;
        const response = await this.$httpService.get(this.url, this.paramsPage);
        let result = pathOr([], ["data", "data", "result"], response);
        this.totalRows = pathOr([], ["data", "data", "total"], response);
        this.totalPages = pathOr([], ["data", "data", "total_pages"], response);
        this.perPage = pathOr([], ["data", "data", "per_page"], response);
        this.permissionButtons = pathOr([], ["data", "permissions"], response);

        if (!result.length) {
          this.table_data = [];
          this.headers_fields = [];
          return;
        }

        if (!this.filterheaders.length > 0) {
          this.filterheaders = response.data.filters.map((x) => {
            return {
              key_filter_caption: x.key_filter_caption,
              key_filter_name: x.key_filter_name,
              key_service: x.key_service,
              open: x.open,
              type: x.type,
              loader: !x.open,
              search_scope: x.search_scope,
            };
          });
        }
        let filters = {};
        Object.keys(result[0]).map((x) => {
          if (x !== `related_competency`) {
            filters[x] = [];
          }
        });
        this.filters = filters;

        this.table_data = [...result];

        if (this.table_data.length) {
          Object.keys(this.allowFields).forEach((item, index) => {
            this.headers_fields.push({
              label: this.allowFields[item],
              key: item,
              sortable: false,
              filter: false,
            });
          });
        }
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
